export const css = {
    root: '_217FEXC3',
    icon: '_23e_tu4L',
    checked: 'BKBx7CS6',
    focused: 'hQTBM5-d',
    focusedStar: '_2DSd0RRW',
    ' _key': 'certwise-theme/dojo/rate'
};
export default css;
